import { useSelector } from "@xstate5/vue";
import { waitFor } from "xstate5";
import { institutionStateActor } from "../state-machines/get-institution-config";

export function useInstitution() {
	const snapshot = useSelector(institutionStateActor, (state) => state);

	const institutionConfig = computed(
		() => snapshot.value.context.booklistConfig,
	);

	const enabledAccessLength = computed(
		() => snapshot.value.context.enabledAccessLength,
	);

	const isIA = computed(() => snapshot.value.context.isIA);
	const isEA = computed(() => snapshot.value.context.isEA);
	const isEAorIA = computed(() => snapshot.value.context.isEAorIA);
	const isAccessProgramEnabled = computed(
		() => snapshot.value.context.isAccessProgramEnabled,
	);
	const isRequirementStatusEnabled = computed(
		() => snapshot.value.context.isRequirementStatusEnabled,
	);
	const institutionRegion = computed(
		() => snapshot.value.context.booklistConfig?.region,
	);
	const institutionId = computed(
		() => snapshot.value.context.booklistConfig?.institution_id,
	);

	async function waitForInstitutionConfig() {
		return waitFor(
			institutionStateActor,
			(snapshot) => ["success", "error"].includes(snapshot.value),
			{
				timeout: 30000,
			},
		);
	}

	return {
		waitForInstitutionConfig,
		institutionConfig,
		institutionRegion,
		institutionId,
		enabledAccessLength,
		isIA,
		isEA,
		isEAorIA,
		isAccessProgramEnabled,
		isRequirementStatusEnabled,
	};
}
